import { DateTimeInput, Field, NumericInput, TextInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { DATETIME_INPUT_COLUMN_WIDTH } from 'Components/Layout/Grid/types';
import {
  IWorksheetComponent,
  WorksheetBalanceFieldSet,
  WorksheetEquipmentDropdown,
  WorksheetGridFieldSection,
  WorksheetRecordGrid,
} from 'Components/Worksheets/Core';
import { DateTimeDataFormat } from 'Lib/Format';

let BsEnMeasurementSection: React.FC<IWorksheetComponent> = () => {
  return (
    <>
      <ListFieldSection heading="Soaking">
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="thermometer" name="Equipment.SoakingThermometer" />
        <Field input={<NumericInput />} name="Measurements.InitialWaterTemperature" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="timer" name="Equipment.Clock" />
        <Field
          input={<DateTimeInput />}
          dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
          name="Measurements.SoakingStartTime"
        />
        <Field
          input={<DateTimeInput />}
          dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
          name="Measurements.SoakingEndTime"
        />
        <Field input={<TextOutput />} name="Measurements.SoakingPeriod" />
        <Field input={<NumericInput />} name="Measurements.MinimumSoakingWaterTemperature" />
        <Field input={<NumericInput />} name="Measurements.MaximumSoakingWaterTemperature" />
      </ListFieldSection>

      <ListFieldSection heading="Water Density">
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="thermometer" name="Equipment.TestThermometer" />
        <Field input={<NumericInput />} name="Measurements.SampleWaterTemperature" />
        <Field input={<TextOutput />} name="Measurements.WaterDensityAtTestTemperature" />
      </ListFieldSection>

      <ListFieldSection heading="Submerged Weighing">
        <WorksheetBalanceFieldSet name="Equipment.MeasurementBalance" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="wire-basket" name="Equipment.WireBasket" />
        <Field input={<NumericInput />} name="Measurements.BasketAndTestPortionMassInWater" />
        <Field input={<NumericInput />} name="Measurements.EmptyBasketMassInWater" />
      </ListFieldSection>

      <ListFieldSection heading="Saturated & Surface-Dried Test Portion">
        <Field input={<TextInput />} name="Measurements.ConstantDryMass.DryingTray.ContainerLabel" maxLength={20} />
        <Field input={<NumericInput />} name="Measurements.ConstantDryMass.DryingTray.ContainerMass" />
        <Field input={<NumericInput />} name="Measurements.ConstantDryMass.DryingTray.WetSoilAndContainerMass" />
        <Field input={<TextOutput />} name="Measurements.ConstantDryMass.DryingTray.WetSoilMass" />
      </ListFieldSection>

      <ListFieldSection heading="Drying">
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="oven"
          name="Measurements.ConstantDryMass.Equipment.Oven"
        />
        <Field input={<NumericInput />} name="Measurements.ConstantDryMass.Equipment.DryingTemperature" />

        <Field input={<DateTimeInput />} name="Measurements.ConstantDryMass.DryingTray.DateTimePlacedInOvenLocal" />
        <WorksheetBalanceFieldSet name="Measurements.ConstantDryMass.Equipment.DryMassBalance" />
      </ListFieldSection>

      <WorksheetGridFieldSection name="Measurements.ConstantDryMass.DryingTray.DryMassReadings">
        <WorksheetRecordGrid
          name="Measurements.ConstantDryMass.DryingTray.DryMassReadings"
          orientation={'vertical'}
          recordProps={{
            enforceAtLeastOneRecord: true,
            preventRemove: (i) => i < 2,
            removeConfirm: {
              confirm: true,
              confirmTitle: 'Delete Dry Mass Reading',
              confirmText: 'Are you sure you want to delete the dry mass reading? Data cannot be recovered.',
              confirmButtonText: 'Delete',
            },
          }}
          fieldSet={[
            {
              name: 'DateTimeRemovedFromOvenLocal',
              component: <Field input={<DateTimeInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
              width: DATETIME_INPUT_COLUMN_WIDTH,
            },
            {
              name: 'DryingTime',
              component: <Field input={<TextOutput />} />,
            },
            {
              name: 'DrySoilAndContainerMass',
              component: <Field input={<NumericInput />} />,
              additionalMessagePaths: ['DrySoilMass'],
            },
          ]}
        />
      </WorksheetGridFieldSection>

      <Field input={<TextOutput />} name="Measurements.ConstantDryMass.DryingTray.ConstantDrySoilMass" />
    </>
  );
};

BsEnMeasurementSection = withInjectedProps(BsEnMeasurementSection);

export { BsEnMeasurementSection };
export default BsEnMeasurementSection;
